module.exports = __webpack_public_path__ + "img/arrow-r-dist.340d1c93.svg";